export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.f2927dd84a58b111546dcfcd69e49e40.css";